import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ConfirmDialog } from '@/components/ConfirmDialog';
import { useDeleteSchedule } from '@/hooks/useDeleteSchedule';
import { useScheduleContext } from '@/pages/Schedule/contexts';
import { useToast } from '@/ui';

type Props = {
  isOpen: boolean;
  onCancel: () => void;
};

export const DeleteConfirmation = ({ isOpen, onCancel }: Props) => {
  const { t } = useTranslation('header');
  const { deleteSchedule, isPending } = useDeleteSchedule();
  const { schedule, scheduleId } = useScheduleContext();
  const toast = useToast();
  const navigate = useNavigate();

  return (
    <ConfirmDialog
      confirmButtonText={t('schedule.delete_confirm.submit')}
      isLoading={isPending}
      isOpen={isOpen}
      title={t('schedule.delete_confirm.title', {
        title: schedule?.title || t('untitled_schedule', { ns: 'common' }),
      })}
      onCancel={onCancel}
      onConfirm={() => {
        deleteSchedule(scheduleId, {
          onSuccess: () => navigate('/'),
          onError: () => toast.error('schedule.delete_confirm.error_toast'),
        });
      }}
    />
  );
};
